import React from 'react';
import {connect} from 'react-redux';
import {prepareKitchenPrintArray, printToKitchenNew} from '../../../common/lib/util';
import {Map} from 'immutable';

class KitchenPrintTest extends React.Component {

  static propTypes = {
      msg: React.PropTypes.object,
    bar: React.PropTypes.object,
    kitchenPrintLength: React.PropTypes.number,
    kitchenPrintType: React.PropTypes.string,
    kitchenPrintAddress: React.PropTypes.string,
    kitchenItemsPrintSeparate: React.PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.testPrint = this.testPrint.bind(this);
  }

  testPrint() {
    const {kitchenPrintType, kitchenPrintAddress, bar, kitchenPrintLength, kitchenItemsPrintSeparate, msg} = this.props;

    let items = Map();
    items = items.set('1', Map({'pcs': 7, 'name': 'Testovací produkt 1'}));
    items = items.set('2', Map({'pcs': 9, 'name': 'Testovací 2'}));
    items = items.set('3', Map({'pcs': 1, 'name': 'produkt 3'}));

    let map = Map({'tableName': 'Testovací stůl', 'number': 4567, 'items': items});
    const printArrayKitchen = prepareKitchenPrintArray(bar.get('name'), map, kitchenItemsPrintSeparate, msg);
    printToKitchenNew(true, kitchenPrintType, kitchenPrintAddress, printArrayKitchen, kitchenPrintLength);
  }

  render() {
    const {kitchenPrintType, msg} = this.props;

    return (
      <div className="table-row">
        <div className="table-cell" style={{width: '55.55%'}}>
          <div className="boxBtn text-left text-black">
          </div>
        </div>
        <div className="table-cell" style={{width: '22.22%'}}>
          <div className="boxBtn text-black text-l"></div>
        </div>
        <div className="table-cell" style={{width: '22.22%'}}>
          <div
            className={`boxBtn color-green text-l ${['escpos-usb', 'escpos-serial', 'escpos-net'].indexOf(kitchenPrintType) > -1 ? '' : 'disabled'}`}>
            <div className="boxBtn-inner" onClick={this.testPrint}>
                  <span>
                      {msg.settings.kitchenPrint.test}
                  </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
  kitchenPrintType: state.device.kitchenPrintType,
  kitchenPrintLength: state.device.kitchenPrintLength,
  kitchenPrintAddress: state.device.kitchenPrintAddress,
  kitchenItemsPrintSeparate: state.device.kitchenItemsPrintSeparate,
  bar: state.bars.get('bar')
}))(KitchenPrintTest);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/KitchenPrintTest.js